<template>
  <button-component class="MediaButton"
    :icon="icon"
    :label="label"
    :meta="meta" />
</template>

<script>
export default {
  name: 'MediaButton',

  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    meta: {
      type: [String, Number]
    }
  }
}
</script>

<style>
@import 'properties';

.MediaButton {
  background-color: var(--c-black-075);
  border-color: var(--c-grey-lt-075);
}

.MediaButton:hover {
  border-color: var(--c-blue);
}

.MediaButton .Button-label {
  color: var(--c-white);
}

.MediaButton .Button-icon .Icon {
  width: 16px !important;
  height: 16px !important;
}

.MediaButton .Button-icon svg {
  fill: var(--c-white) !important;
}
</style>



// WEBPACK FOOTER //
// MediaButton.vue?7d508e96